.km{min-width:14rem;}